import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function ChaptersPage() {
  return <InstituteCrudPage config={entityConfigs['chapters']} />;
}
